import api from './api'
import { UserAdmin, CreateUserRequest, UpdateUserRequest } from './types'

export const usersService = {
  async getAll(params?: {
    search?: string
    role?: string
    is_active?: boolean
  }): Promise<UserAdmin[]> {
    const response = await api.get<UserAdmin[]>('/auth/users/', { params })
    return response.data
  },

  async getById(id: number): Promise<UserAdmin> {
    const response = await api.get<UserAdmin>(`/auth/users/${id}/`)
    return response.data
  },

  async create(data: CreateUserRequest): Promise<UserAdmin> {
    const response = await api.post<UserAdmin>('/auth/users/', data)
    return response.data
  },

  async update(id: number, data: UpdateUserRequest): Promise<UserAdmin> {
    const response = await api.patch<UserAdmin>(`/auth/users/${id}/`, data)
    return response.data
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/auth/users/${id}/`)
  },
}

export default usersService
